/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonPrimary, H4Bold, Caption, Box, Input } from '@comeon/ui';
import { Sidebar, SidebarHeader, SidebarContent, SidebarFooter } from '../../../sidebar/index.js';
import IconArrowLinkLeft from '../../../misc/icon-arrow-link-left.js';
import { updateDisplayName } from '../ducks/we-spin-duck.js';
import useTranslations from '../../../translation/use-translations';
import useIsMounted from '~/hooks/use-is-mounted';
import { WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import { selectDisplayName } from '../ducks/we-spin-selectors.js';

const BoxWithBackgroundColor = styled(Box)`
	background-color: var(--button-wrapper-bg);
`;

const WeSpinChangeDisplayName = () => {
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS);
	const isMounted = useIsMounted();

	const displayName = useSelector(selectDisplayName);
	const [usernameValue, setUsernameValue] = useState('');
	const [usernameChanged, setUsernameChanged] = useState(false);
	const [usernameValid, setUsernameValid] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!displayName) {
			setUsernameValue('');
		} else {
			setUsernameValue(displayName);
		}
	}, [displayName]);

	const onChangeHandler = useCallback(
		e => {
			setUsernameValue(e.target.value);
			const valid = e.currentTarget.checkValidity();
			setUsernameValid(valid);
			if (displayName !== e.target.value && valid) {
				setUsernameChanged(true);
			} else {
				setUsernameChanged(false);
			}
		},
		[displayName]
	);

	const handleUpdate = useCallback(() => {
		dispatch(updateDisplayName(usernameValue)).then(() => {
			if (isMounted.current) {
				setUsernameChanged(false);
			}
		});
	}, [dispatch, isMounted, usernameValue]);

	if (isLoadingTranslations) return null;

	return (
		<div className="modal-view">
			<Sidebar>
				<SidebarHeader
					transparent
					Icon={<IconArrowLinkLeft to="/account/settings" className="js-back page-head__back u-show" />}
				>
					<H4Bold className="page-head__title">{tr.WE_SPIN_CHANGE_USERNAME_WE_SPIN_NAME}</H4Bold>
					<div className="page-head__right-side" />
				</SidebarHeader>
				<SidebarContent>
					<div className="u-pl1 u-pr1 u-pt1">
						<form id="johnny-test" autoComplete="nope" noValidate="">
							<fieldset className="u-relative u-oh">
								<Input
									label={tr.WE_SPIN_CHANGE_USERNAME_NAME}
									id="username"
									name="username"
									type="text"
									value={usernameValue}
									onChange={onChangeHandler}
									validationMessage={
										!usernameValid && tr.WE_SPIN_CHANGE_USERNAME_NAME_VALIDATION_ERROR
									}
									pattern="[a-zA-Z][a-zA-Z0-9-_\.]{1,20}"
									required
								/>
							</fieldset>
						</form>
						<Caption className="u-text-c u-pt1">{tr.WE_SPIN_CHANGE_USERNAME_NAME_INFO}</Caption>
					</div>
				</SidebarContent>
				<SidebarFooter>
					<BoxWithBackgroundColor flex="1" mb="0" p="5">
						<ButtonPrimary onClick={handleUpdate} disabled={!usernameChanged}>
							{tr.WE_SPIN_CHANGE_USERNAME_NAME_SAVE}
						</ButtonPrimary>
					</BoxWithBackgroundColor>
				</SidebarFooter>
			</Sidebar>
		</div>
	);
};

export default WeSpinChangeDisplayName;
